/* tslint:disable */
/* eslint-disable */

/**
 * 0 = P
 * 0 = Point
 * 1 = Curve
 * 1 = L
 * 2 = A
 * 2 = Surface
 * 3 = Collapse
 * -3 = Dontcare
 * -2 = True
 * -1 = Unknown
 * -1 = False
 */
export enum Dimension {
  P = 0,
  Point = 0,
  Curve = 1,
  L = 1,
  A = 2,
  Surface = 2,
  Collapse = 3,
  Dontcare = -3,
  True = -2,
  Unknown = -1,
  False = -1
}
